import React, { Suspense, lazy, useState } from 'react';
import { track } from '../../../../analytics';
import planImage from '../../../../assets/plan-de-table-mariage.webp';
import planImageMobile from '../../../../assets/plan-de-table-mariage-mobile.webp';

const loadDemo = () => import('./SeatingDemo');
const SeatingDemo = lazy(loadDemo);

// Image de l'état initial exact de la démo (ordinateur / téléphone) : au clic,
// la vraie démo prend sa place sans que rien ne bouge. À recapturer si la démo change.
const Shot: React.FC = () => (
  <picture>
    <source media="(max-width: 599px)" srcSet={planImageMobile} width={700} height={1985} />
    <img
      src={planImage}
      width={1400}
      height={947}
      alt="Démo du plan de table de mariage en ligne : invités à placer, tables rondes nommées et invités placés par glisser-déposer"
    />
  </picture>
);

// Capture de l'outil, remplacée par la vraie démo interactive au clic.
// La démo (plan de table + données fictives) n'est téléchargée qu'à ce moment-là :
// la page reste légère pour le premier affichage et pour Google.
const SeatingTry: React.FC = () => {
  const [live, setLive] = useState(false);

  if (live) {
    return (
      <div className="mg-shot mk-container">
        <Suspense
          fallback={
            <div className="mg-try">
              <Shot />
            </div>
          }
        >
          <SeatingDemo />
        </Suspense>
      </div>
    );
  }

  return (
    <figure className="mg-shot mk-container">
      <div className="mg-try">
        <Shot />
        <div className="mg-try-overlay">
          <button
            type="button"
            className="mkt-btn primary mk-btn-lg"
            onClick={() => {
              track('tool_use', { tool: 'seating_demo' });
              setLive(true);
            }}
            onPointerEnter={loadDemo}
            onFocus={loadDemo}
          >
            Tester en direct
          </button>
          <span>Sans inscription · Rien n’est enregistré</span>
        </div>
      </div>
    </figure>
  );
};

export default SeatingTry;
